import { useFilterSearchParams } from "@/utils/hooksUtils";
import { Card } from "antd";
import { DEFAULT_SPLIT_COMMISSIONS_QUERY_PARAMS } from "../api";
import { SplitCommissionsFilterForm } from "../components/forms/SplitCommissionsFilterForm";
import { SplitCommissionsTable } from "../components/tables/SplitCommissionsTable";
import { SplitCommissionsFilterPageRequest } from "../types";

export const SplitCommissionsListContainer = () => {
  const searchParams = useFilterSearchParams<SplitCommissionsFilterPageRequest>({
    params: [
      "orderBy",
      "orderDirections",
      "report",
      "institutionIds",
      "gainerIds",
      "originalBatchIds",
      "payoutBatchIds",
    ],
    defaultQueryParamsObject: DEFAULT_SPLIT_COMMISSIONS_QUERY_PARAMS,
  });

  return (
    <>
      <SplitCommissionsFilterForm searchParams={searchParams} />

      <Card className="card-box">
        <SplitCommissionsTable searchParams={searchParams} />
      </Card>
    </>
  );
};
